// Sync the compare-styles promo card (bottom-right of the first featured
// collection block on Shop Adults / Shop Kids) to match the banner
// illustration (top-left of the same block) in height. CSS can't pin them
// because the banner's height is driven by the products grid next to it,
// not a fixed value — measure and apply.

(function () {
  var DESKTOP_MIN = 990;

  function syncPromoHeights() {
    var wrappers = document.querySelectorAll(
      '.featuredCollectionGrid--has-compare-promo .featuredCollectionGridProductsWrapper'
    );
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var promo = wrapper.querySelector('.featuredCollectionGridComparePromo');
      if (!promo) return;

      // Clear inline height so we re-measure freshly each tick.
      promo.style.height = '';

      if (window.innerWidth < DESKTOP_MIN) return;

      var banner = wrapper.querySelector('.featuredCollectionGridBanner');
      if (!banner) return;

      var bannerHeight = banner.getBoundingClientRect().height;
      if (!bannerHeight) return;

      promo.style.height = bannerHeight + 'px';
    });
  }

  var resizeTimer = null;
  function onResize() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncPromoHeights, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPromoHeights);
  } else {
    syncPromoHeights();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncPromoHeights);
  }

  window.addEventListener('resize', onResize);
})();
